<div class="extractMobile collapsed" [id]="'deal' + indexDeal">
  <!--!isInsuranceEdition  -->
  <div class="title">
    <div class="name">
      @if (validDealEditable()) {
      <label class="checkboxWrapper" [for]="indexDeal + 'deal'">
        <input
          type="checkbox"
          [id]="indexDeal + 'deal'"
          [checked]="deal.isSelected"
          [disabled]="
            !deal.payments ||
            !deal.payments.length ||
            creationUser != authService.currentUserIds ||
            isPackageInactive(deal) ||
            isPackageCompanyMismatch(deal) ||
            status === 'SAVED'
          "
          (click)="toggleSelection($event, indexDeal, deal.id)"
        />
        <span class="checkmark"></span>
        <span class="description"
          >{{ getFinancialProduct(deal?.financialSetup?.financialProduct) }}
          {{ deal?.financialCondition?.term + ' meses' }}</span
        >
      </label>
      }@else {
      <label class="checkboxWrapper" [for]="indexDeal + 'deal'">
        <span class="description"
          >{{ getFinancialProduct(deal?.financialSetup?.financialProduct) }}
          {{ deal?.financialCondition?.term + ' meses' }}</span
        >
      </label>
      }
      @if (canExtendDealValidity(deal)) {
      <button
        type="button"
        class="extendValidityAction"
        tp="Extender vigencia de la propuesta"
        (click)="onExtendDealValidityClick($event, deal.id)"
        [disabled]="isExtendingDealValidity(deal)"
      >
        {{ isExtendingDealValidity(deal) ? 'Extendiendo…' : 'Extender vigencia' }}
      </button>
      }
    </div>
    <!-- Incluir la clase "active" cuando se está mostrando el menú-->
    @if (
      status !== 'SAVED' &&
      isValidForm &&
      validDealEditable() &&
      (creationUser == null || creationUser == authService.currentUserIds)
    ) {
      <div class="contextualMenuMobile" [ngClass]="{ active: isMenuRowOpen(getRowKey(deal?.id, indexDeal)) }">
        <a
          class="toggle"
          aria-haspopup="menu"
          aria-controls="menu-id"
          role="button"
          [attr.aria-expanded]="!!openRowOption()"
          [id]="getMobileMenuTriggerId(getRowKey(deal?.id, indexDeal))"
          (click)="toggleMobileMenuOptions($event, getRowKey(deal?.id, indexDeal))"
          >Ver/Ocultar menu</a
        >
        <div
          class="menuContent"
          role="menu"
          id="menu-id"
          appBackdropOverlay
          appOutSideClick
          [isActive]="!!openRowOption()"
          [ignoreElements]="[getMobileMenuTriggerId(getRowKey(deal?.id, indexDeal))]"
          [activeTarget]="openRowOption()"
          [currentTarget]="getRowKey(deal?.id, indexDeal)"
          (outSideClick)="closeMobileMenuOptions()"
          style="z-index: 40"
        >
          <ul>
            <li role="menuitem">
              <a (click)="edit.emit(deal.id)" class="iconAndText edit"> Editar </a>
            </li>
            <li role="menuitem">
              <a (click)="duplicate.emit(deal.id)" class="iconAndText duplicate">Duplicar</a>
            </li>
            <li role="menuitem">
              <a (click)="delete.emit(deal.id)" class="iconAndText delete">Eliminar</a>
            </li>
          </ul>
        </div>
      </div>
    }
  </div>
  <div class="package">
    <p>{{ deal.financialSetup.financialSetupName }}</p>
    @if (isPackageInactive(deal)){
    <span class="tag rechazado">Paquete Financiero no vigente</span>
    }
    @if (isPackageCompanyMismatch(deal)){
    <span class="tag rechazado">Paquete no disponible para esta compañía</span>
    }
    @if (deal.validityEndDate) {
    <span class="tag">{{ deal.valid ? 'Vigente hasta ' : 'Vencida desde ' }}{{ formatValidityEndDate(deal.validityEndDate) }}</span>
    }
    @if (showLoyaltyFinancialPackageBadge(deal)) {
    <span class="loyaltyBadge" tp="Paquete Loyalty"
      ><img src="./assets/images/icons/loyalty.svg" alt="Ícono loyalty"
    /></span>
    }
  </div>
  <div class="resume">
    <div class="wrapper">
      <div class="gridData">
        <div>
          <span>Producto Financiero</span>
          <span>{{ getFinancialProduct(deal.financialSetup.financialProduct) }}</span>
        </div>
        <div>
          <span>Plazo</span>
          <span>{{ deal?.financialCondition?.term + ' meses' }}</span>
        </div>
        <div>
          <span>Precio unitario con IVA</span>
          <span>{{ model.price | currency : '' : '' }}</span>
        </div>
        <div>
          <span>Tasa al cliente</span>
          <span>{{ deal?.financialCondition?.nominalRate.toFixed(2) + ' %' }}</span>
        </div>
        @if(deal.financialSetup.financialProduct != "PURE_LEASING" ) {
        <div>
          <span>Enganche</span>
          <span>
            {{ deal?.result?.downpaymentAmount | currency : '' : '' }}
          </span>
        </div>
      }
        <div>
          <span>Comisión por apertura</span>
          <span>{{ deal?.result?.openingfeeAmount | currency : '' : '' }}</span>
        </div>
        <div>
          <span>Seguro del vehículo</span>
          <span [style.color]="showInsuranceVehicle(deal) === 'Recotizar seguro' ? '#dc3545' : ''">
            {{ showInsuranceVehicle(deal) === 'Recotizar seguro' ? 'Recotizar seguro' : (showInsuranceVehicle(deal) | currency : '' : '') }}
          </span>
        </div>
        <div>
          <span>Seguro de vida</span>
          <span> {{ deal?.result?.insuranceAmount | currency : '' : '' }}</span>
        </div>
        <div>
          <span>Gastos de ratificación</span>
          <span>{{ deal?.result?.confirmationExpensesAmount | currency : '' : '' }}</span>
        </div>
        <div>
          <span>Pago inicial</span>
          <span>{{ deal?.result?.initialPayment | currency : '' : '' }}</span>
        </div>
        <div>
          <span>Monto a financiar</span>
          <span>{{ deal?.result?.financialAmount | currency : '' : '' }}</span>
        </div>
        <div>
          <span>Pago mensual</span>
          <span>{{ deal?.result?.monthlyPayment | currency : '' : '' }}</span>
        </div>
      </div>
    </div>
    <a class="accordionControl" (click)="viewDeal(indexDeal)"
      ></a
    >
  </div>
  <div class="accordionWrapper">
    <div>
      <app-view-deal-standard-quote-mobile
        [payments]="deal.payments"
        [specialPayments]="deal.specialPayments"
        [grace]="deal?.grace"
        [idDeal]="deal.id"
        [id]="idQuote"
        [financialProduct]="deal.financialProduct"
        [currency]="deal?.currency"
        [insurance]="deal?.insurance"
      ></app-view-deal-standard-quote-mobile>
    </div>
  </div>
</div>
